import React from 'react';
import ProductionUnitBasicInfoComponent from './production-unit-basic-info.component';
import ProductionUnitAddressComponent from './production-unit-address.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

function ProductionUnitComponent ({ handleInnerbasicFormChange, back, onInnerFormChange, handleFormSubmit, productionPlant, selectedAddress, selectedProductionUnit }: any) {
    const tabItems=[
        {
            id:1,
            title:'Basic Information',
            component: <ProductionUnitBasicInfoComponent
            onInnerFormChange={onInnerFormChange}
            productionPlant={productionPlant}
            selectedProductionUnit={selectedProductionUnit}
        />,
        isVisible:true,
        },
        {
            id:2,
            title:'Address',
            component: <ProductionUnitAddressComponent
            handleInnerbasicFormChange={handleInnerbasicFormChange}
            selectedAddress={selectedAddress}
            onInnerFormChange={onInnerFormChange} 
            selectedProductionUnit={selectedProductionUnit}
            />,
            isVisible:true,
        }
     
      
      ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
           <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
          
            type="submit"
        >
          Save
        </button>
      </div>
     </div>
  );
}
export default ProductionUnitComponent;
